/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var injectStyle = function injectStyle(style) {
  var styleElement = document.createElement("style");
  var styleSheet = null;
  document.head.appendChild(styleElement);
  styleSheet = styleElement.sheet;
  styleSheet.insertRule(style, styleSheet.cssRules.length);
};

export { injectStyle as default };
//# sourceMappingURL=injectStyle.js.map
